module.exports = __webpack_public_path__ + "img/gp-s.f2e88850.png";